import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DocumentViewerComponent} from './documentViewer.component';
import {DocumentViewerPageComponent} from './documentViewerPage.component';
import {DocumentViewerToolbarComponent} from './documentViewerToolbar.component';
import {
  EXTERNAL_LINK, FILE_DOWNLOAD, LONG_ARROW_DOWN, LONG_ARROW_UP,
  MINUS, PLUS, REDO, TIMES, UNDO
} from '../../icons/common';
import {IconService} from '../../services/icon.service';
import {MatIconModule} from '@angular/material/icon';
import {CoreModule} from '../../core.module';

@NgModule({
  declarations: [
    DocumentViewerComponent,
    DocumentViewerPageComponent,
    DocumentViewerToolbarComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    CoreModule,
  ],
  exports: [
    DocumentViewerComponent,
    DocumentViewerPageComponent,
    DocumentViewerToolbarComponent,
  ],
})
export class DocumentViewerModule {

  constructor(private _iconService: IconService) {
    this._iconService.registerIcons([MINUS, PLUS, UNDO, REDO, LONG_ARROW_UP, LONG_ARROW_DOWN, FILE_DOWNLOAD, EXTERNAL_LINK, TIMES]);
  }

}
